import styled from 'styled-components';

export const LogoContainer = styled.div`
  width: 184px;
  height: 184px;
  box-shadow: 0px 4px 18px rgba(92, 84, 122, 0.14);
  top: -92px;
`;
